var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1463 5.606H3.84766V2.01423C3.84766 0.900893 4.75254 0 5.8708 0H22.1231C23.2414 0 24.1463 0.900893 24.1463 2.01423V5.606Z",
    fill: "#4088FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7595 24.9984H2.24047C1.00366 24.9984 0 23.9992 0 22.7678V5.32825C0 4.0969 1.00366 3.09766 2.24047 3.09766H25.7595C26.9963 3.09766 28 4.0969 28 5.32825V22.7678C28 23.9992 26.9963 24.9984 25.7595 24.9984Z",
    fill: "url(#paint0_linear_1020_772)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 24.9992H25.7589C26.9957 24.9992 27.9993 24 27.9993 22.7686V15.707L18.666 24.9992Z",
    fill: "url(#paint1_linear_1020_772)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208984 23.7054C0.564615 24.4686 1.33908 24.9996 2.24001 24.9996H4.66621L13.9995 12.6074L0.208984 23.7054Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 12.6074L4.66602 24.9996H25.7589C26.4939 24.9996 27.1458 24.6456 27.5568 24.0988L13.9993 12.6074Z",
    fill: "#4BB7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2986 8.33256C24.2986 7.6795 23.7691 7.15234 23.1132 7.15234C22.4572 7.15234 21.9277 7.6795 21.9277 8.33256C21.9277 8.98561 22.4572 9.51277 23.1132 9.51277C23.7652 9.51277 24.2986 8.98167 24.2986 8.33256Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1020_772",
    x1: 21.8531,
    y1: 27.5877,
    x2: 6.24966,
    y2: 0.44213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1020_772",
    x1: 26.1104,
    y1: 25.141,
    x2: 22.5028,
    y2: 18.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeTitleIcon);
export default __webpack_public_path__ + "static/media/resume_title_icon.efe2ca44431688b508547e86a70a0153.svg";
export { ForwardRef as ReactComponent };